// import React from 'react';

// // import {
// //   TextNodeModal,
// //   TextSnippetNodeModal,
// //   NoteNodeModal,
// //   DocumentNodeModal,
// //   ImageNodeModal,
// //   ProtocolNodeModal,
// //   RisSearchModal,
// //   SurfaceNodeModal,
// //   QuestionnaireNodeModal,
// //   BackgroundNodeModal,
// // } from 'routes/surface/style';
// import LinkArrow from 'components/canvas/components/link-arrow';
// import CollaboratingUsersCursors, {
//   useCollaboratingCursorListeners,
// } from 'routes/surface/components/collaborating-users-cursors';
// import SurfaceSubscriptionListeners from 'routes/surface/components/surface-subscriptions-listeners';
// import useNodeSearchParams from 'routes/surface/hooks/use-node-search-params';
// import { useSurfaceNodeModalsOperations } from 'routes/surface/hooks/use-surface-node-modals-context';
// import { useHistory, useParams } from 'react-router-dom';
// import { configuration } from 'components/pspdf';
// import { Line } from 'react-konva';
// import useFetchSurfaceNodes from 'components/canvas/components/nodes/hooks/use-fetch-surface-nodes';
// // import { Container } from '@material-ui/core';
// import Stack from '@mui/material/Stack';
// import { Container, Grid, List, ListItem, Typography } from '@mui/material';
// import { Fab, ListItemText, Toolbar } from '@material-ui/core';
// import styled from 'styled-components';
// import useFetchLoggedUser from 'hooks/use-fetch-logged-user';
// import { useQuery } from '@apollo/client';
// import { homeSurfaceQuery } from 'graphql/surface/queries/home-surface';
// import client from 'services/apollo-client';
import query, {
  surfaceNodesQuery,
} from 'graphql/surface-node/queries/surface-nodes';

// import { yellow } from '@mui/material/colors';
// import { ThemeProvider, createTheme } from '@mui/material/styles';
// import { useTheme } from 'styled-components';
// import {
//   Div,
//   HeaderStyledLogoIconImmo,
//   HeaderStyledLogoIconImmoText,
// } from 'routes/list';

// const Item2 = ({ node, onClick }) => {
//   var sub = null;

//   if (node.type == 'TEXT') {
//     sub = (
//       <React.Fragment>
//         <Typography
//           sx={{ display: 'inline' }}
//           component="div"
//           variant="body2"
//           color="text.primary">
//           {node.text}
//         </Typography>
//       </React.Fragment>
//     );
//   }

//   if (node.type == 'NOTE') {
//     sub = (
//       <React.Fragment>
//         <Typography
//           sx={{ display: 'inline' }}
//           component="div"
//           variant="body2"
//           color="text.primary">
//           {node.text}
//         </Typography>
//         <Typography
//           // sx={{ display: 'inline' }}
//           component="div"
//           variant="body2"
//           color="text.primary">
//           {`http://localhost:3000/share/template/${node.text.split(':')[2]}/${
//             node.surface.id
//           }`}
//         </Typography>
//       </React.Fragment>
//     );
//   }

//   return (
//     <ListItemText
//       primary={node.name}
//       secondary={sub}
//       onClick={node.type == 'SUB_SURFACE' ? onClick : null}
//     />
//   );
// };

// const Fab_ = styled(Fab)`
//   /* background-color: red; */
//   /* height: 100vh; */

//   /* position: absolute; */
//   /* right: 0; */

//   /* position: absolute; */
//   margin: 0;
//   top: auto;
//   right: 20;
//   bottom: 20;
//   left: auto;
//   position: fixed;
// `;
// const Item = styled.div`
//   /* background-color: red; */
//   /* height: 100%; */

//   /* position: absolute; */
// `;
// // function Item({ node }) {}

// function DetailNik() {
//   const { id } = useParams<{ id: string }>();

//   const history = useHistory();

//   // const { user } = useFetchLoggedUser();

//   const { nodes, loading } = useFetchSurfaceNodes(id);
//   const [subCellData, setSubCellData] = React.useState([]);
//   const { data, loading: loadingCell } = useQuery<any>(homeSurfaceQuery, {
//     client,
//     // fetchPolicy: 'network-only',
//   });
//   // const { showNodeModal } = useSurfaceNodeModalsOperations();

//   // useNodeSearchParams(showNodeModal);

//   // useCollaboratingCursorListeners(id);

//   // React.useEffect(() => {
//   //   if (process.env.NODE_ENV === 'production') {
//   //     setTimeout(() => PSPDFKit.preloadWorker(configuration), 3000);
//   //   }
//   // }, []);

//   const navigateToSurface = React.useCallback((surfaceId: string) => {
//     history.push('/immo-ox/list/' + surfaceId);
//   }, []);

//   const navigateToTemplate = React.useCallback((surfaceId: string) => {
//     history.push('/immo-ox/template/' + surfaceId);
//   }, []);

//   const isRoot = data?.homeSurface?.data?.id == id;

//   console.log('Data ', isRoot, data);

//   const no = isRoot ? nodes.filter((n) => n.type == 'SUB_SURFACE') : nodes;

//   const subCells = React.useMemo(
//     () => nodes.filter((n) => n.type == 'SUB_SURFACE'),
//     [nodes],
//   );
//   // const subCells =

//   React.useEffect(() => {
//     (async () => {
//       if (subCellData.length > 0) {
//         return;
//       }
//       const d = subCells.map(async (cell) => {
//         const surface = cell.id;
//         return await query({ input: { filter: { surface: cell.id } } });
//       });
//       const data = await (await Promise.all(d)).map((p) => p.data);
//       console.log(
//         'SUBS',
//         data.map((t) => t),
//       );
//       setSubCellData(data);
//     })();

//     //  return d;
//   }, [subCells, subCellData]);

//   console.log('AAAA', nodes);
//   if (loading || loadingCell) {
//     return 'Loading';
//   }

//   return (
//     // <>
//     //   <Div>
//     //     <Toolbar></Toolbar>
//     //     <Container maxWidth="lg">

//     <Div>
//       <HeaderStyledLogoIconImmo />
//       <HeaderStyledLogoIconImmoText />
//       <Toolbar></Toolbar>
//       <Container maxWidth="lg">
//         {/* <Stack spacing={2}>

//           {nodes.map((n) => {
//             return <Item node={n}> </Item>;
//           })}
//         </Stack> */}

//         {/* <Grid container spacing={2}>
//             <Grid item xs={6} md={8}>
//               <Item>xs=6 md=8</Item>
//             </Grid>
//             <Grid item xs={6} md={4}>
//               <Item>xs=6 md=4</Item>
//             </Grid>
//             <Grid item xs={6} md={4}>
//               <Item>xs=6 md=4</Item>
//             </Grid>
//             <Grid item xs={6} md={8}>
//               <Item>xs=6 md=8</Item>
//             </Grid>
//           </Grid> */}

//         <List
//           sx={{
//             height: 'calc(90vh - 100px)',
//             overflow: 'auto',
//             width: '100%',
//             maxWidth: 1200,
//             bgcolor: 'background.paper',
//           }}>
//           {no.map((node, index) => {
//             return (
//               <ListItem alignItems="flex-start">
//                 {/* <ListItemAvatar>
//           <Avatar alt="Remy Sharp" src="/static/images/avatar/1.jpg" />
//         </ListItemAvatar> */}
//                 {/* {renderItem(node)} */}
//                 <Item2 node={node} onClick={() => navigateToSurface(node.id)} />
//                 {node.type == 'SUB_SURFACE' && subCellData[index] && (
//                   <>
//                     {subCellData[index]
//                       .filter((n) => n.type != 'NOTE')
//                       .map((c) => {
//                         return (
//                           <Item2
//                             node={c}
//                             // onClick={() => navigateToSurface(node.id)}
//                           />
//                         );
//                       })}
//                   </>
//                 )}
//               </ListItem>
//             );
//           })}
//         </List>
//         {isRoot && (
//           <Fab_
//             color="primary"
//             aria-label="add"
//             onClick={() => navigateToTemplate(id)}>
//             ADD
//           </Fab_>
//         )}
//       </Container>
//     </Div>
//   );
// }

// const theme = createTheme({
//   palette: {
//     primary: {
//       main: yellow[500],
//     },
//   },
// });

// function Themed(props) {
//   const themeStyled = useTheme();
//   return (
//     <ThemeProvider theme={{ ...theme, ...themeStyled }}>
//       <DetailNik {...props} />
//     </ThemeProvider>
//   );
// }

// // return <ThemeProvider theme={theme}>...</ThemeProvider>;

// export default Themed;

import React from 'react';

// import {
//   TextNodeModal,
//   TextSnippetNodeModal,
//   NoteNodeModal,
//   DocumentNodeModal,
//   ImageNodeModal,
//   ProtocolNodeModal,
//   RisSearchModal,
//   SurfaceNodeModal,
//   QuestionnaireNodeModal,
//   BackgroundNodeModal,
// } from 'routes/surface/style';
import LinkArrow from 'components/canvas/components/link-arrow';
import CollaboratingUsersCursors, {
  useCollaboratingCursorListeners,
} from 'routes/surface/components/collaborating-users-cursors';
import SurfaceSubscriptionListeners from 'routes/surface/components/surface-subscriptions-listeners';
import useNodeSearchParams from 'routes/surface/hooks/use-node-search-params';
import { useSurfaceNodeModalsOperations } from 'routes/surface/hooks/use-surface-node-modals-context';
import { useHistory, useParams } from 'react-router-dom';
import { configuration } from 'components/pspdf';
import { Line } from 'react-konva';
import useFetchSurfaceNodes from 'components/canvas/components/nodes/hooks/use-fetch-surface-nodes';
// import { Container } from '@material-ui/core';
import Stack from '@mui/material/Stack';
import {
  Container,
  Grid,
  List,
  ListItem,
  Rating,
  Typography,
  Button,
  TextField,
  ListItemText,
  Toolbar,
} from '@mui/material';
// import { Fab, ListItemText, Toolbar } from '@material-ui/core';
import styled from 'styled-components';
import useFetchLoggedUser from 'hooks/use-fetch-logged-user';
import { useMutation, useQuery } from '@apollo/client';
import { homeSurfaceQuery } from 'graphql/surface/queries/home-surface';

import { red, yellow } from '@mui/material/colors';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { useTheme } from 'styled-components';

import client from 'services/apollo-client';
import Table from './table';
import logo from 'styles/icons/immoOx-Text.png';
import logo1 from 'styles/icons/LogoImmo.png';
import { templates } from 'routes';
import Box from '@mui/material/Box';
import { querstionairesQuery } from 'routes/listDetail';
import { updateSurfaceMutation } from 'graphql/surface-node/mutations/update-surface';
import { pick } from 'lodash';
import { withPortratitGuard } from 'routes/share/template-page/guard';
import { media } from 'styles/settings';
import { templateList } from 'routes/templates/tempates';
import { DocumentNodeModal } from 'routes/surface/components/surface-node-modals/style';
import { toast } from 'services/toast';
// import SurfaceNodeModals from 'routes/surface/components/surface-node-modals';
// import from './style';

const theme = createTheme({
  palette: {
    type: 'light',
    primary: {
      main: '#FFE736',
    },
    secondary: {
      main: '#f50057',
    },
    text: {
      primary: '#ffffff',
    },
  },
});
const Item2 = ({ node, onClick }) => {
  var sub = null;

  if (node.type == 'TEXT') {
    sub = (
      <React.Fragment>
        <Typography
          sx={{ display: 'inline' }}
          component="div"
          variant="body2"
          color="text.primary">
          {node.text}
        </Typography>
      </React.Fragment>
    );
  }

  if (node.type == 'NOTE') {
    sub = (
      <React.Fragment>
        <Typography
          sx={{ display: 'inline' }}
          component="div"
          variant="body2"
          color="text.primary">
          {node.text}
        </Typography>
        <Typography
          // sx={{ display: 'inline' }}
          component="div"
          variant="body2"
          color="text.primary">
          {`http://localhost:3000/share/template/${node.text.split(':')[2]}/${
            node.surface.id
          }`}
        </Typography>
      </React.Fragment>
    );
  }

  return (
    <ListItemText
      primary={node.name}
      secondary={sub}
      onClick={node.type == 'SUB_SURFACE' ? onClick : null}
    />
  );
};

export const Div = styled.div`
  /* background-color: red; */
  height: 100vh;
  background: ${({ theme }) => theme.background};
  /* position: absolute; */
`;

const Title = styled.div`
  /* background-color: red; */
  /* height: 100vh; */
  color: ${({ theme }) => theme.text};
  text-align: center;
  margin-bottom: 20px;
  font-size: 40px;
  /* position: absolute; */
`;

const Title2 = styled.div`
  /* background-color: red; */
  /* height: 100vh; */
  color: ${({ theme }) => theme.text};
  text-align: center;
  margin-bottom: 4px;
  font-size: 30px;
  /* position: absolute; */
`;

const Text = styled.div`
  /* background-color: red; */
  /* height: 100vh; */
  color: ${({ theme }) => theme.text};
  text-align: left;
  margin-bottom: 10px;
  font-size: 20px;
  margin-left: 10px;
  /* position: absolute; */
`;

const TextClick = styled.div`
  /* background-color: red; */
  /* height: 100vh; */
  color: ${({ theme }) => theme.text};
  text-align: left;
  margin-bottom: 10px;
  font-size: 20px;
  margin-left: 10px;
  cursor: pointer;
  text-decoration: underline;
  /* position: absolute; */
`;

const Label = styled.div`
  /* background-color: red; */
  /* height: 100vh; */
  color: ${({ theme }) => theme.text};
  text-align: left;
  margin-bottom: 2px;
  font-size: 14px;
  /* position: absolute; */
`;

const AAA = styled.div`
  /* background-color: red; */
  /* height: 100vh; */
  color: ${({ theme }) => theme.text};
  text-align: left;
  margin-bottom: 16px;
  margin-top: 16px;
  font-size: 14px;
  /* position: absolute; */
`;

const AddButton = styled.div`
  margin-top: 40px;
  margin-left: auto;
  margin-right: auto;
  background-color: white;
  /* height: 100vh; */
  color: ${({ theme }) => theme.textInv};
  text-align: center;
  margin-bottom: 20px;
  font-size: 20px;
  padding: 8px;
  width: 300px;
  cursor: pointer;

  /* position: absolute; */
`;

const Item = styled.div`
  /* background-color: red; */
  /* height: 100%; */

  /* position: absolute; */
`;
// function Item({ node }) {}

export const HeaderStyledLogoIconImmo = styled.img.attrs(({ src }) => ({
  src: logo1,
  alt: 'Article Cover',
}))`
  position: absolute;
  /* width: 128px; */
  height: 80px;
  object-fit: contain;
  top: 8px;
  left: 8px;
`;

export const HeaderStyledLogoIconImmoText = styled.img.attrs(({ src }) => ({
  src: logo,
  alt: 'Article Cover',
}))`
  position: absolute;
  /* width: 128px; */
  height: 80px;
  object-fit: contain;
  bottom: 8px;
  left: 8px;
  ${media.mediaQueries.mobile`
      display:none;
  `}
`;

export const Arrows = styled.div`
  /* background-color: red; */
  /* height: 100vh; */
  color: ${({ theme }) => theme.text};
  text-align: left;
  margin-bottom: 20px;
  font-size: 20px;
  position: absolute;
  right: 20px;
  top: 20px;
`;

export const Link = styled.div`
  color: ${({ theme }) => theme.text};
  text-align: left;
  margin-bottom: 2px;
  font-size: 14px;
  padding: 4px;
  cursor: pointer;
`;

function ListNik() {
  const { id, entry } = useParams<{ id: string; entry: String }>();

  const ref = React.useRef();

  const history = useHistory();

  // const { user } = useFetchLoggedUser();

  const { nodes, loading } = useFetchSurfaceNodes(id);
  const [subCellData, setSubCellData] = React.useState([]);
  const { data, loading: loadingCell } = useQuery<any>(homeSurfaceQuery, {
    client,
    // fetchPolicy: 'network-only',
  });
  // const { showNodeModal } = useSurfaceNodeModalsOperations();

  // useNodeSearchParams(showNodeModal);

  // useCollaboratingCursorListeners(id);

  // React.useEffect(() => {
  //   if (process.env.NODE_ENV === 'production') {
  //     setTimeout(() => PSPDFKit.preloadWorker(configuration), 3000);
  //   }
  // }, []);
  const [updateSurface] = useMutation(updateSurfaceMutation);

  function surfaceOperation(data) {
    const keys = ['name', 'id', 'rating', 'description', 'ratingComment'];

    const input = pick(data, keys);

    // if (input.id) {
    //   return updateSurface({ variables: { input } });
    // }

    return updateSurface({ variables: { input } });
  }

  const [rating, setRating] = React.useState(-1);
  const [ratingComment, setRatingComment] = React.useState(null);

  const [hasChanged, setHasChanged] = React.useState(false);

  const saveClicked = React.useCallback(async () => {
    console.log('CLICKED');
    const result = await surfaceOperation({
      id: entry,
      rating: `${rating}`,
      ratingComment: ratingComment,
    });
    if (result.data) {
      setHasChanged(false);
      toast.success('Gespeichert');
    }
    if (result.errors) {
      toast.error(result.errors[0]);
    }
    console.log('SAVED? ', result);
  }, [rating, ratingComment]);

  const navigateToSurface = React.useCallback((surfaceId: string) => {
    history.push('/immo-ox/detail/' + surfaceId);
  }, []);

  const navigateToTemplate = React.useCallback((surfaceId: string) => {
    history.push('/immo-ox/template/' + surfaceId);
  }, []);

  const navigateToSurfaceEntry = React.useCallback(
    (surfaceId: string, entryId: String) => {
      history.push('/immo-ox/detail/' + surfaceId + '/' + entryId);
    },
    [],
  );

  // console.log('AAAA', nodes);
  // if (loading || loadingCell) {
  //   return 'Loading';
  // }

  const isRoot = true;

  console.log('Data ', isRoot, data);

  const no = isRoot ? nodes.filter((n) => n.type == 'SUB_SURFACE') : nodes;

  const subCells = React.useMemo(
    () => nodes.filter((n) => n.type == 'SUB_SURFACE'),
    [nodes],
  );
  // const subCells =

  React.useEffect(() => {
    (async () => {
      if (subCellData.length > 0) {
        return;
      }
      const d = subCells.map(async (cell) => {
        const surface = cell.id;
        return await query({ input: { filter: { surface: cell.id } } });
      });
      const data = await (await Promise.all(d)).map((p) => p.data);
      console.log(
        'SUBS',
        data.map((t) => t),
      );
      if (data.length > 0) {
        setSubCellData(data);
      }
    })();

    //  return d;
  }, [subCells, subCellData]);

  const { loading: loadingQ, error, data: q } = useQuery(querstionairesQuery, {
    variables: { id: id },
    fetchPolicy: 'network-only',
    client,
  });

  let surface = null;

  React.useEffect(() => {
    console.log(' USE EFF ', nodes, rating);
    if (rating == -1 && nodes[0]?.rating) {
      setRating(nodes[0]?.rating);
      // setRatingComment(nodes[0]?.ratingComment);
    }
    if (ratingComment == undefined && nodes[0]?.ratingComment) {
      // setRating(nodes[0]?.rating);
      setRatingComment(nodes[0]?.ratingComment);
    }
  }, [nodes, rating]);

  console.log('AAAA', subCellData[0], q);
  if (loading || loadingCell || loadingQ) {
    return 'Loading';
  }

  let nodeX = nodes.find((node) => node.type == 'NOTE');

  let questionnaire = q.questionnaireForSurface.data;

  surface = questionnaire.surface;

  var template = [...questionnaire.questions];

  template = template.sort((a, b) => {
    // console.log(' SORT ', a.order, b.order);
    return a.order - b.order;
  });

  console.log('XXX SURFACE ', q, rating, ratingComment);

  // console.log('XXX SURFACE ', sort);
  // let answerCells = subCells.filter( (c,i) => subCellData[i]!= null )

  // let answerCells = subCells.filter( (c,i) => subCellData[i]!= null )

  let cellIndex = subCells.findIndex((s) => s?.id == entry);
  let cell = subCellData[cellIndex];
  let nextCell = subCellData[cellIndex + 1] && subCells[cellIndex + 1];
  let previousCell = subCellData[cellIndex - 1] && subCells[cellIndex - 1];

  var templ = undefined;
  if (questionnaire?.templateId) {
    templ = templateList.find((entry) => entry.id == questionnaire?.templateId);
  }

  const hasRating = templ?.hasRating === true;

  return (
    <>
      <Div>
        <HeaderStyledLogoIconImmo />
        <HeaderStyledLogoIconImmoText />
        <Toolbar></Toolbar>
        {isRoot && (
          <Container maxWidth="lg">
            <Arrows>
              {
                <Link
                  onClick={() => {
                    navigateToSurface(id, nextCell?.id);
                  }}>
                  Zur Übersicht
                </Link>
              }
              {previousCell?.id && (
                <Link
                  onClick={() => {
                    navigateToSurfaceEntry(id, previousCell.id);
                  }}>
                  Vorherige Anfrage
                </Link>
              )}
              {nextCell?.id && (
                <Link
                  onClick={() => {
                    navigateToSurfaceEntry(id, nextCell?.id);
                  }}>
                  Nächste Anfrage
                </Link>
              )}
            </Arrows>
            <Title>Anfrage</Title>
            <Label>Projektname:</Label>
            <Text>{surface?.name || '-'}</Text>
            {/* <Label>Beschreibung:</Label>
            <Text>{surface?.description || '-'}</Text> */}
            {/* <Text>Kommentar: - </Text> */}
            {/* <Text>Kommentar: - </Text> */}
            {/* <Text>
              Link:
              {`http://localhost:3000/share/template/${
                nodeX?.text?.split(':')[2]
              }/${nodeX?.surface?.id}`}{' '}
            </Text>
            <Text>Status: akitv</Text> */}

            {/* <Title>
              {JSON.stringify(
                no.find((t) => t.__typename == 'SurfaceNoteNode'),
              )}
            </Title> */}
            {/* {JSON.stringify(data)} */}
            {hasRating && (
              <Stack spacing={2}>
                {/* <Label>Bewertung</Label> */}
                <Rating
                  name="read-only"
                  defaultValue={rating}
                  size={'large'}
                  onChange={(_, v) => {
                    console.log('RATING CHANGES', v);
                    setHasChanged(true);
                    setRating(v);
                  }}
                />
                <Label>Kommentar</Label>

                <TextField
                  inputProps={{ color: 'yellow' }}
                  sx={{ color: 'yellow' }}
                  variant="standard"
                  defaultValue={ratingComment}
                  onChange={(c, v) => {
                    console.log('RATING COMMENT CHANGES', v, c.target.value);
                    setHasChanged(true);
                    setRatingComment(c.target.value);
                  }}></TextField>
                <Button
                  sx={{ width: 100 }}
                  fullWidth={false}
                  disabled={!hasChanged}
                  onClick={saveClicked}>
                  Speichern
                </Button>
              </Stack>
            )}
            <Box
              component="div"
              sx={{
                mt: 2,
                display: 'flex',
                flexDirection: 'column',
                height: '50vh',
                overflow: 'hidden',
                // overflowY: 'scroll',
                // justifyContent="flex-end" # DO NOT USE THIS WITH 'scroll'
              }}>
              <Title2>Fragebogen</Title2>
              <Stack
                spacing={2}
                sx={{ maxHeight: 'calc(60vh - 108px)', overflowY: 'scroll' }}>
                {/* <Text>{JSON.stringify(template)}</Text> */}

                {template.map((t) => {
                  const cellEntry = cell?.find((c) => c.name == t.question);
                  if (t.type == 'hint') {
                    return;
                  } else {
                    return (
                      <>
                        <AAA>
                          <Label>Frage</Label>
                          <Text>{t.question}</Text>
                          <Label>Antwort</Label>
                          <Text>
                            {
                              cell?.find((c) => c.name == t.question)
                                ?.answerType
                            }
                          </Text>
                          {
                            t.type == 'document' &&
                              // "DOCUMENT "

                              cellEntry && (
                                <TextClick
                                  onClick={() => {
                                    console.log(
                                      'OPEN PRESSES',
                                      cellEntry,
                                      t,
                                      ref,
                                    );
                                    ref.current.setData(cellEntry);
                                    ref.current.show();
                                    // ref
                                  }}>
                                  Dokument Anzeigen
                                </TextClick>
                              )
                            // JSON.stringify(cellEntry)
                          }
                          {
                            t.type == 'document' &&
                              // "DOCUMENT "

                              !cellEntry && (
                                <Text>Kein Dokument hochgeladen</Text>
                              )
                            // JSON.stringify(cellEntry)
                          }
                        </AAA>
                      </>
                    );
                  }
                  // return JSON.stringify(t.text);
                })}
                {/* {} */}
                {/* <Text>{JSON.stringify(entry)}</Text>
                <Text>{JSON.stringify(cellIndex)}</Text>
                <Text>{JSON.stringify(cell)}</Text> */}

                {/* <Table
              entries={no}
              subCells={subCellData}
              handleClickP={(a, node) => {
                navigateToSurface(node.id);
              }}></Table> */}
                {/* {isRoot && (
              <AddButton onClick={() => navigateToTemplate(id)}>
                Neue Mieterqualifizierung starten
              </AddButton>
            )} */}
              </Stack>
            </Box>
          </Container>
        )}
        {!isRoot && (
          <List
            sx={{
              height: 'calc(90vh - 200px)',
              overflow: 'auto',
              width: '100%',
              maxWidth: 1200,
              bgcolor: 'background.paper',
            }}>
            {no.map((node) => {
              return (
                <ListItem alignItems="flex-start">
                  <Item2
                    node={node}
                    onClick={() => navigateToSurface(node.id)}
                  />
                </ListItem>
              );
            })}
          </List>
        )}
      </Div>
      {/* // {isLoading === false && <SurfaceSubscriptionListeners surface={id} />}

      // <Canvas
      //   id={id}
      //   isLoading={isLoading}
      //   renderBelowCanvas={({ stage }) => (
      //     <>
      //       <TextNodeModal ref={modalRefs.textNodeModal} onHide={onModalHide} />

      //       <NoteNodeModal ref={modalRefs.noteNodeModal} onHide={onModalHide} />
      //       <TextSnippetNodeModal
      //         ref={modalRefs.textSnippetNodeModal}
      //         onHide={onModalHide}
      //       />
      //       <DocumentNodeModal
      //         ref={modalRefs.documentNodeModal}
      //         onHide={onModalHide}
      //       />
      //       <SurfaceNodeModal
      //         ref={modalRefs.surfaceNodeModal}
      //         onHide={onModalHide}
      //       />
      //       <ProtocolNodeModal
      //         ref={modalRefs.protocolNodeModal}
      //         onHide={onModalHide}
      //       />
      //       <BackgroundNodeModal ref={modalRefs.backgroundNodeModal} onHide={onModalHide} />
      //       <QuestionnaireNodeModal
      //         ref={modalRefs.questionnaireNodeModal}
      //         onHide={onModalHide}
      //       />
      //       <ImageNodeModal
      //         ref={modalRefs.imageNodeModal}
      //         onHide={onModalHide}
      //       />
      //       <RisSearchModal
      //         ref={modalRefs.risSearchModal}
      //         onHide={onModalHide}
      //       />

      //       <TopLeftMenu />

      //       <TopRightMenu />

      //       <SideMenu
      //         stage={stage}
      //         showNodeModal={showNodeModal}
      //         modalTypeShown={modalTypeShown}
      //         surface={id}
      //       />

      //       <SideDrawer />

      //       <NotificationSideDrawer />

      //       <IndicatorZoneMenu>
      //         <GlobalLinkZoneIndicator />
      //         <ClipboardZoneIndicator />
      //       </IndicatorZoneMenu>

      //       {isLoading === false && (
      //         <MiniMap surface={id} nodes={nodes} isLoading={isLoading} />
      //       )}
      //       <SurfaceLinkContextMenu />
      //     </>
      //   )}>
      //   {() => {
      //     if (error) return null;
      //     console.log("XXX" , nodes)
      //     return (
      //       <>
      //         <Nodes
      //           surface={id}
      //           nodes={nodes.filter(n => n.__typename === "SurfaceBackgroundNode")}
      //           nodeEdges={nodeEdges}
      //           showNodeModal={showNodeModal}
      //           navigateToSurface={navigateToSurface}
      //         />
      //          <Nodes
      //           surface={id}
      //           nodes={nodes.filter(n => n.__typename !== "SurfaceBackgroundNode")}
      //           nodeEdges={nodeEdges}
      //           showNodeModal={showNodeModal}
      //           navigateToSurface={navigateToSurface}
      //         />
      //         <CollaboratingUsersCursors />
      //       </>
      //     );
      //   }} */}
      {/* <ToolbarProvider>
        <SurfaceSubscriptionListeners surface={id} />
        <FileUploadZone surface={id}>
          <Canvas id={id}>
            <Nodes surface={id} navigateToSurface={navigateToSurface} />
            <LinkArrow surface={id} />
            <CollaboratingUsersCursors />
          </Canvas>
        </FileUploadZone>
        <SurfaceNodeModals />

        <TopLeftMenu />

        <TopRightMenu />

        <SideMenu surface={id} />

        <PaintMenu />

        <SideDrawer />

        <NotificationSideDrawer />

        <MiniMap surface={id} />
      </ToolbarProvider> */}

      <DocumentNodeModal ref={ref} onHide={() => {}} />
    </>
  );
}

function Themed(props) {
  const themeStyled = useTheme();

  return (
    <ThemeProvider theme={{ ...theme, ...themeStyled }}>
      <ListNik {...props} />
    </ThemeProvider>
  );
}

// return <ThemeProvider theme={theme}>...</ThemeProvider>;

export default withPortratitGuard(Themed);
